import React, { Component } from "react"
import { PropTypes } from "prop-types"
import _ from 'lodash';
import { Row,Col,Button,FormGroup,FormControl,InputGroup } from "react-bootstrap"
import { getRequest } from '../../../utils/functions/httpRequest';
import { orange, eventstatus, StatusKey } from '../../../utils/constants'
import { URL } from '../../../config'
import { getActiveSeasons } from '../../../components/common/api'

const SearchBy = {
	Name: 'name',
	DirectorName: 'dirname',
	Director: 'email',
	Status: 'status',
	Date: 'date',
	Membership: 'membership',
  All: 'all',
  EventEmail: 'eventEmail'
}

const SearchByDescription = {
	EventName: "Event's name",
	Director: "Director's email",
	DirectorName: "Director's name",
	Status: 'Status',
	Date: 'Date',
	All:'All',
  Membership: "Director's member Id",
  EventEmail: "Event's Email"
}

class SearchBar extends Component { 
	constructor(props)
  {
    super(props)   
    this.state = { 
			seasonId:'',
			searchBy: SearchBy.Status,
			searchValue:'',
			searchMode:false,
			statusSearchValue:'all',
			seasons:[],
		}
		this.handleSearch = this.handleSearch.bind(this)
		this.handleSearchByChange = this.handleSearchByChange.bind(this)
		this.setSearchTextField = this.setSearchTextField.bind(this)
		this.setSearchDateField = this.setSearchDateField.bind(this)
		this.setModes = this.setModes.bind(this)
    this.setSeasons = this.setSeasons.bind(this)
    this.setSelectValues = this.setSelectValues.bind(this)
    this.handleSearchByStatusChange = this.handleSearchByStatusChange.bind(this)
    this.handleSeasonChange = this.handleSeasonChange.bind(this)
		this.handleValueChange = this.handleValueChange.bind(this)
		this.setSearchByOptions = this.setSearchByOptions.bind(this)
	}
	
	componentDidMount()	{
		const _this = this;
		getActiveSeasons().then(function(response) {
			_this.setState({ 
				seasons: response.data,
				seasonId: response.data[0].id
			})
		})
	}

	handleSeasonChange = (event) => {
		const season = event.target.value
		this.props.onSearchCriteriaChange();	
		this.setState({
			seasonId:season
		});
	}

	handleSearch() {
	const _this = this;
		const {
			searchBy,
			searchValue,
			statusSearchValue,
			seasonId
		} = this.state

		let searchCriteria = searchValue

		if(searchBy === SearchBy.Status) {
				searchCriteria = statusSearchValue
		}
		this.setState({  searchMode:true });

		const searchendpoint = `/search/${seasonId}/${searchBy}/${searchCriteria}`
		const  postEventURL = `${URL.postevent}${searchendpoint}`
		const token = this.props.token
		const { OnSearchResults } = this.props;
		getRequest(postEventURL,'json',token).then(function(response) {
			OnSearchResults(response.data);
			_this.setState({				
				searchMode:false
			});
		});
  }
	handleSearchByChange = (event) => {
		const searchby = event.target.value
		let freetextsearch = true

		if((searchby == SearchBy.Status))
		{
            freetextsearch  = false
		}
		this.setModes(freetextsearch,searchby,'')
		this.props.SearchByChange();
	}

  handleSearchByStatusChange(event) {
    const searchvalue = event.target.value;
    this.setState({ statusSearchValue: searchvalue });
  }

  handleValueChange(evt) {
	const searchValue = evt.target.value;
	this.setState({ searchValue: searchValue });
}

	isFreeText = () => { 
		const { searchBy, freeTextSearch } = this.state
		return searchBy != SearchBy.All && searchBy != SearchBy.Date && freeTextSearch
	}

	isSelect = () => { return this.state.searchBy == SearchBy.Status }

	isDateField = () => { return this.state.searchBy == SearchBy.Date }

  setSelectValues = () => {
    const attrs = {
      name: 'searchvalue',
      componentClass: 'select',
      style: { minWidth: "280px" }
    }
    switch (this.state.searchBy) {
    case SearchBy.Status:
    {
      const pendingpost = _.find(eventstatus, { key: StatusKey.PendingPost })
      const completed = _.find(eventstatus, { key: StatusKey.Completed })


      return (
        <FormControl {...attrs} defaultValue="all" onChange={this.handleSearchByStatusChange} style={{ minWidth: '250px', borderRadius: '0', height: '36px' }}>
              <option value="all">All</option>
              <option value={pendingpost.description}>{pendingpost.description}</option>
              <option value={completed.description}>{completed.description}</option>
            </FormControl>
      )
    }
    }
  }

  setSearchTextField = () => {
	const fldtype = 'text'
	return (<FormControl type={fldtype} placeholder={this.state.searchBy === SearchBy.Membership ? 'xxxxx-xxxxxxx' : 'Enter value'} style={{ minWidth:'270px' }} value={this.state.searchValue} onChange={this.handleValueChange}/>)
}
  setSearchDateField = () => {
		const fldtype = 'date'
		return (<FormControl type={fldtype} style={{ minWidth:'150px' }} className='unstyled' onChange={this.handleValueChange}/>)
	}
	setModes = (freetextsearch=null,searchby=null,searchValue='') => {
		this.setState({
			freeTextSearch: freetextsearch !== null ? freetextsearch : this.state.freeTextSearch,
			searchBy: searchby !== null ? searchby : this.state.searchBy,
			searchValue
		})
	}
	setSeasons()
	{
		const { seasons } = this.state;
		const option = seasons.map((season) =>{
       return (<option key={season.id} value={season.id}>{ season.description }</option> );
		});
		return option;
	}

	setSearchByOptions = () => {
		
		const { SearchByOptions, isAdministrator } = this.props

		return ([
      (SearchByOptions ? SearchByOptions.includes(SearchBy.Status) : true) && <option value={SearchBy.Status} key='3'>{SearchByDescription.Status}</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.DirectorName) : true) && <option hidden={!isAdministrator} value={SearchBy.DirectorName} key='1'>{ SearchByDescription.DirectorName }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Name) : true)  && <option value={SearchBy.Name} key='2'>{ SearchByDescription.EventName }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Membership) : true)  && <option hidden={!isAdministrator} value={SearchBy.Membership} key='4'>{ SearchByDescription.Membership }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Date) : true)  && <option value={SearchBy.Date} key='5'>{ SearchByDescription.Date }</option>,
			(SearchByOptions ?	SearchByOptions.includes(SearchBy.Director) : true)  && <option hidden={!isAdministrator} value={SearchBy.Director} key='6'>{ SearchByDescription.Director }</option>,
      (SearchByOptions ? SearchByOptions.includes(SearchBy.EventEmail) : true) && <option hidden={!isAdministrator} value={SearchBy.EventEmail} key='7'>{SearchByDescription.EventEmail}</option>
    ])
	}

	render()
  {
    const {
      SearchByDefault
    } = this.props;

		const { 
			searchMode,
			searchBy,
			searchValue, 
			seasons
		} = this.state;

		const activeSeasons = (_.find(seasons,{ isSeasonSet: true }) !== undefined);

	return (<Row>
		<Col xs={12}>
			<div className="stacked-filter-panel">
				<FormGroup controlId="searchby" className="searchby-filter">
					<FormControl  componentClass="select" onChange = { this.handleSeasonChange } style={{ minWidth:'120px',borderRadius:'0' }}>
					{
						this.setSeasons() 
					}
					</FormControl>
          <FormControl defaultValue={SearchByDefault ? SearchByDefault : SearchBy.Status} componentClass="select" placeholder="All" onChange = { this.handleSearchByChange } style={{ minWidth:'180px',borderRadius:'0' }}>
						{
							this.setSearchByOptions()
						}
					</FormControl>
					<InputGroup>
						{ 
							this.isFreeText() && 
							this.setSearchTextField()
            }
            {
              this.isSelect() &&
              this.setSelectValues()
            }
						{
							this.isDateField() &&
							this.setSearchDateField()
						}
						<InputGroup.Button>
							<Button onClick={ this.handleSearch } style={{ color:orange, marginLeft:'0px', minHeight:'34px' }} disabled={ searchValue.length < 3 && searchBy != SearchBy.Status || !activeSeasons }>
								<i className={ searchMode === true ? "fa fa-spinner fa-spin":"fa fa-search"} aria-hidden="true"  />
							</Button>
						</InputGroup.Button>
					</InputGroup>
				</FormGroup>
			</div>
		</Col>
	</Row>)
	}
}
SearchBar.propTypes = {
  isAdministrator: PropTypes.bool,
  SearchByDefault: PropTypes.string,
  OnSearchResults: PropTypes.func,
	onSearchCriteriaChange: PropTypes.func,
	token: PropTypes.string,
	SearchByChange: PropTypes.func,
	SearchByOptions:PropTypes.array,
}
export default SearchBar;


// WEBPACK FOOTER //
// ./src/containers/postevent/components/searchbar.js